module.exports = __webpack_public_path__ + "img/reward-wolf.bc43ec49.png";